import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs, useMediaQuery, useTheme, Box } from '@material-ui/core';
import TablaGrupoLicenciasSoftware from './tablaGrupoLicenciasSoftware';
import TablaMarcasSoftware from './tablaMarcasSoftware';
import TablaVersionesSoftware from './tablaVersionesSoftware';
import TablaAgrupacionesSoftware from './tablaAgrupacionSoftware';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
export default function TablaListadosGruposLicenciasSoftware() {
  const [selectedTab, setSelectedTab] = useState(0);
  const theme = useTheme();
  const smBreak = useMediaQuery(theme.breakpoints.down('sm'));

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={selectedTab}
          onChange={handleChange}
          aria-label="basic tabs"
          centered={!smBreak}
          variant={smBreak ? 'scrollable' : 'standard'}
          scrollButtons={smBreak ? 'on' : 'off'}
        >
          <Tab label="Listado Agrupaciones de Software" {...a11yProps(0)} />
          <Tab label="Marcas de Software" {...a11yProps(1)} />
          <Tab label="Versiones de Software" {...a11yProps(2)} />
          <Tab label="Agrupaciones de Software" {...a11yProps(3)} />
        </Tabs>
      </Box>
      <TabPanel value={selectedTab} index={0}>
        <TablaGrupoLicenciasSoftware />
      </TabPanel>
      <TabPanel value={selectedTab} index={1}>
        <TablaMarcasSoftware />
      </TabPanel>
      <TabPanel value={selectedTab} index={2}>
        <TablaVersionesSoftware />
      </TabPanel>
      <TabPanel value={selectedTab} index={3}>
        <TablaAgrupacionesSoftware />
      </TabPanel>
    </Box>
  );
}
